import * as entry from 'api/entry';
import { EntryResponse } from 'api/entry/types';
import { createActionFactories } from 'shared/helpers/actions';

const { createAsync } = createActionFactories('_resources/entry');

export const getEntry = createAsync<string, EntryResponse>('GET_ENTRY', async (params) => {
  return await entry.getEntry(params);
});
